import { render, staticRenderFns } from "./ForkliftComp.vue?vue&type=template&id=83aa1996&scoped=true"
import script from "./ForkliftComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ForkliftComp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForkliftComp.vue?vue&type=style&index=0&id=83aa1996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa1996",
  null
  
)

export default component.exports